import React from 'react';

export const PayloadContext = React.createContext(null);